import clsx from 'clsx'
import {CrudProvider} from '../../../../services/loggedin/CrudContext'
import {FormComponent} from '../../../parts/crud/Form'
import {Field} from 'formik'
import {LinkedList} from '../../../parts/components/LinkedList'

export const FormExtractor = () => {
  return (
    <>
      <CrudProvider api='extractors'>
        <FormComponent
          fetch={{servers: 'extractors/servers', brokers: 'extractors/brokers'}}
          redirect='/extractors'
          text_modificato='Estrattore modificato con successo'
          text_nuovo='Estrattore creato con successo'
        >
          {(formik, data, remoteErrors, isEdit) => (
            <>
              <div className='row mb-6'>
                <div className='col-md-12'>
                  <div className='form-group'>
                    <label htmlFor='codename' className='required fw-bold fs-6'>
                      GUID
                    </label>
                    <input
                      type='text'
                      className={clsx('form-control ', {
                        'is-invalid': formik.touched.codename && formik.errors.codename,
                        'is-valid': formik.touched.codename && !formik.errors.codename,
                      })}
                      id='codename'
                      {...formik.getFieldProps('codename')}
                    />
                    {formik.touched.codename && formik.errors.codename ? (
                      <em className='text-danger'>{formik.errors.codename}</em>
                    ) : null}
                  </div>
                </div>
              </div>

              <div className='row mb-6'>
                <div className='col-md-12'>
                  <div className='form-group'>
                    <label htmlFor='name_extractor' className='required fw-bold fs-6'>
                      Nome
                    </label>
                    <input
                      placeholder='Nome estrattore'
                      type='text'
                      className={clsx('form-control ', {
                        'is-invalid': formik.touched.name_extractor && formik.errors.name_extractor,
                        'is-valid': formik.touched.name_extractor && !formik.errors.name_extractor,
                      })}
                      id='name_extractor'
                      {...formik.getFieldProps('name_extractor')}
                    />
                    {formik.touched.name_extractor && formik.errors.name_extractor ? (
                      <em className='text-danger'>{formik.errors.name_extractor}</em>
                    ) : null}
                  </div>
                </div>
              </div>

              <div className='row mb-6'>
                <div className='col-md-8'>
                  <div className='form-group'>
                    <label htmlFor='ftp_host' className='required fw-bold fs-6'>
                      Host FTP
                    </label>
                    <input
                      placeholder='Hostname FTP'
                      type='text'
                      className={clsx('form-control ', {
                        'is-invalid': formik.touched.ftp_host && formik.errors.ftp_host,
                        'is-valid': formik.touched.ftp_host && !formik.errors.ftp_host,
                      })}
                      id='ftp_host'
                      {...formik.getFieldProps('ftp_host')}
                    />
                    {formik.touched.ftp_host && formik.errors.ftp_host ? (
                      <em className='text-danger'>{formik.errors.ftp_host}</em>
                    ) : null}
                  </div>
                </div>
                <div className='col-md-4'>
                  <div className='form-group'>
                    <label htmlFor='ftp_port' className='required fw-bold fs-6'>
                      Porta FTP
                    </label>
                    <input
                      placeholder='Porta FTP'
                      type='text'
                      className={clsx('form-control ', {
                        'is-invalid': formik.touched.ftp_port && formik.errors.ftp_port,
                        'is-valid': formik.touched.ftp_port && !formik.errors.ftp_port,
                      })}
                      id='ftp_port'
                      {...formik.getFieldProps('ftp_port')}
                    />
                    {formik.touched.ftp_port && formik.errors.ftp_port ? (
                      <em className='text-danger'>{formik.errors.ftp_port}</em>
                    ) : null}
                  </div>
                </div>
              </div>

              <div className='row mb-6'>
                <div className='col-md-6'>
                  <div className='form-group'>
                    <label htmlFor='ftp_username' className='required fw-bold fs-6'>
                      Username FTP
                    </label>
                    <input
                      placeholder='Username FTP'
                      type='text'
                      className={clsx('form-control ', {
                        'is-invalid': formik.touched.ftp_username && formik.errors.ftp_username,
                        'is-valid': formik.touched.ftp_username && !formik.errors.ftp_username,
                      })}
                      id='ftp_username'
                      {...formik.getFieldProps('ftp_username')}
                    />
                    {formik.touched.ftp_username && formik.errors.ftp_username ? (
                      <em className='text-danger'>{formik.errors.ftp_username}</em>
                    ) : null}
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='form-group'>
                    <label htmlFor='ftp_passwd' className='required fw-bold fs-6'>
                      Password FTP
                    </label>
                    <input
                      type='text'
                      className={clsx('form-control ', {
                        'is-invalid': formik.touched.ftp_passwd && formik.errors.ftp_passwd,
                        'is-valid': formik.touched.ftp_passwd && !formik.errors.ftp_passwd,
                      })}
                      id='ftp_passwd'
                      {...formik.getFieldProps('ftp_passwd')}
                    />
                    {formik.touched.ftp_passwd && formik.errors.ftp_passwd ? (
                      <em className='text-danger'>{formik.errors.ftp_passwd}</em>
                    ) : null}
                  </div>
                </div>
              </div>

              <div className='row mb-6'>
                <div className='col-md-12'>
                  <div className='form-group'>
                    <label htmlFor='params' className='fw-bold fs-6'>
                      Parametri di configurazione
                    </label>
                    <textarea
                      style={{height: '250px'}}
                      type='text'
                      className={clsx('form-control ', {
                        'is-invalid': formik.touched.params && formik.errors.params,
                        'is-valid': formik.touched.params && !formik.errors.params,
                      })}
                      id='params'
                      {...formik.getFieldProps('params')}
                      placeholder='param1=val1'
                    ></textarea>
                    {formik.touched.params && formik.errors.params ? (
                      <em className='text-danger'>{formik.errors.params}</em>
                    ) : null}
                  </div>
                </div>
              </div>

              <div className='row mb-6'>
                <div className='col-md-12 '>
                  <div className='form-check form-switch form-check-custom form-check-solid'>
                    <input
                      type='checkbox'
                      className={clsx('form-check-input', {
                        'is-invalid': formik.touched.autobalance && formik.errors.autobalance,
                        'is-valid': formik.touched.autobalance && !formik.errors.autobalance,
                      })}
                      name='autobalance'
                      onChange={(e) => {
                        formik.setFieldValue('autobalance', e.target.checked ? 1 : 0)
                      }}
                      checked={formik.values.autobalance === 1}
                    />{' '}
                    <label
                      style={{cursor: 'pointer'}}
                      onClick={(e) => {
                        formik.setFieldValue('autobalance', formik.values.autobalance === 1 ? 0 : 1)
                      }}
                      htmlFor='autobalance'
                      className='ms-3 fw-bold fs-6'
                    >
                      Gestisci questo estrattore in bilanciamento automatico
                    </label>
                  </div>
                </div>
              </div>

              <div className='row mb-6'>
                <div className='col-md-12'>
                  <label htmlFor='servers' className='required fw-bold fs-6'>
                    Server Associati
                  </label>
                  <LinkedList
                    is_valid={formik.touched.servers && !formik.errors.servers}
                    is_invalid={formik.touched.servers && formik.errors.servers}
                    datalist_a={data.servers}
                    datalist_b={formik.values.servers}
                    cannotMoveA='Impossibile allocare un server senza codice'
                    onChange={(servers: any) => {
                      formik.setFieldValue('servers', servers)
                    }}
                    itemFilter={(item: any, search: string) => {
    
                      if (search === '') {
                        return true
                      }
                      return (
                        item.server_host.toLowerCase().includes(search.toLowerCase()) ||
                        item.server_code?.toLowerCase().includes(search.toLowerCase())
                      )
                    }}
                    canMove={(item: any, list_from: string) => {
                    
                      if (list_from === 'a') {
                        return item.server_code != null
                      } else {
                        return true
                      }
                    }}
                  >
                    {(item: any, index: number, list: string) => (
                      <>
                        <span
                          className={clsx('', {
                            'text-danger': list === 'a' && item.server_code == null,
                            'text-success': list === 'a' && item.server_code != null,
                          })}
                        >
                          Host: {item.server_host} - Code: {item.server_code}
                        </span>
                      </>
                    )}
                  </LinkedList>

                  {formik.touched.servers && formik.errors.servers ? (
                      <em className='text-danger'>{formik.errors.servers}</em>
                    ) : null}
                </div>
              </div>



              <div className='row mb-6'>
                <div className='col-md-12'>
                  <label htmlFor='ftp_passwd' className='required fw-bold fs-6'>
                    Brokers Associati
                  </label>
                  <LinkedList
                    is_invalid={formik.touched.brokers && formik.errors.brokers}
                    is_valid={formik.touched.brokers && !formik.errors.brokers}
                    datalist_a={data.brokers}
                    datalist_b={formik.values.brokers}
                   
                    onChange={(brokers: any) => {
                      formik.setFieldValue('brokers', brokers)
                    }}
                    itemFilter={(item: any, search: string) => {
                      if (search === '') {
                        return true
                      }
                      const port = item.broker_port+'';
                      const broker = item.broker_host+':'+port;
                      return (
                        broker.includes(search.toLowerCase()) 
                      )
                    }}
                 
                  >
                    {(item: any, index: number, list: string) => (
                      <>
                         {item.broker_host}:{item.broker_port}
                      </>
                    )}
                  </LinkedList>

                  {formik.touched.servers && formik.errors.servers ? (
                      <em className='text-danger'>{formik.errors.servers}</em>
                    ) : null}
                </div>
              </div>
            </>
          )}
        </FormComponent>
      </CrudProvider>
    </>
  )
}
